import React, { useEffect, useState } from "react";
import { todayWorkflowContactData } from "../common/Helper";
import CancelDeleteModal from "./CancelDeleteModal";
import { useStateProvider } from "../common/StateProvider";
import TodayWorkflowItemProfile from "./TodayWorkflowItemProfile";

const NewContactsItem = () => {
  const { setTodaysWorkflowProfile, setTodaysWorkflowIndex } =
    useStateProvider(); // Get Profile
  const {
    deleteModal,
    setDeleteModal,
    deletModalHeading,
    setdeletModalHeading,
    setTodayWorkflowUpdate,
  } = useStateProvider(); //DELETE MODEL

  const { profileItemPage, setProfileItemPage } = useStateProvider(); //TODAY WORKFLOW ITEM PROFILE PAGE
  const [todayWorkflowContactArray, setTodayWorkflowContactArray] = useState([
    ...todayWorkflowContactData,
  ]);
  const [deleteItemIndex, setDeleteItemIndex] = useState(null);

  // Function to show the Productivity modal
  const opendeleteModal = (value, index) => {
    setDeleteModal(true);
    setdeletModalHeading(value.newContactModeltext);
    setDeleteItemIndex(index); // Store the index
  };

  // Function to show the Today Workflow Item Profile Page
  const openProfileItemPage = (value, index) => {
    setProfileItemPage(true);
    setTodaysWorkflowProfile(value);
    setTodaysWorkflowIndex(index);
    setTodayWorkflowUpdate(todayWorkflowContactArray);
  };

  // OVERLAY BEHIND FILTER MODEL
  const overLayHidden = () => {
    setProfileItemPage(!profileItemPage);
  };

  // OVERFLOW HIDDEN WHEN FILTER MODEL OPEN
  useEffect(() => {
    if (profileItemPage) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [profileItemPage]);

  const deleteCard = () => {
    if (deleteItemIndex !== null) {
      const updatedData = [...todayWorkflowContactArray];
      updatedData.splice(deleteItemIndex, 1);
      setTodayWorkflowContactArray(updatedData);
      setDeleteModal(false); // Close the modal after deletion
      setDeleteItemIndex(null);
    }
  };
  return (
    <>
      <div className="w-[500px] xm:w-full md:w-auto overflow-x-auto overflow_x_scroll_style">
        {todayWorkflowContactArray.map((value, index) => (
          <div
            className="p-[7px_10px] cursor-pointer rounded-md border-[0.2px] border-solid border-black/10 bg-white hover:shadow-workflow_item_card_shadow duration-300  mb-2"
            key={index}>
            <div className="flex items-center justify-between">
              <div
                onClick={() => openProfileItemPage(value, index)}
                className="flex items-center gap-4 w-full ">
                <img src={value.newContactImg} alt="teams" />
                <div>
                  <div className=" flex items-center gap-4">
                    <h5 className="text-sm 3xl:text-[16px] font-normal text-black">
                      {value.newContactNameText}
                    </h5>
                    <div className="flex gap-1">
                      <span>{value.newContactStatusIcon}</span>
                      <p
                        className={`${value.levelTextColor} text-xs 3xl:text-[14px] font-normal pr-1`}>
                        {value.newContactTeamLevelText}
                      </p>
                    </div>
                    <p
                      className={` ${value.newContactLabelBtnBgColor} text-[8px] 3xl:text-[10px] font-bold text-white p-[4px_10px] rounded-[38px] `}>
                      {value.newContactLabelBtn}
                    </p>
                  </div>
                </div>
              </div>
              <div className=" flex items-center gap-[6px] cursor-pointer">
                <span onClick={() => opendeleteModal(value, index)}>
                  {value.deleteWorkflowIcon}
                </span>
                <span onClick={() => openProfileItemPage(value, index)}>
                  {value.rightArrow}
                </span>
              </div>
            </div>
          </div>
        ))}
        {deleteModal && (
          <CancelDeleteModal
            deleteModal={deleteModal}
            setDeleteModal={setDeleteModal}
            deletModalHeading={deletModalHeading}
            deleteCard={deleteCard}
          />
        )}
        <div className="fixed right-0 md:right-4 top-0 z-30">
          {profileItemPage && (
            <TodayWorkflowItemProfile
              setProfileToggle={setProfileItemPage}
              setProfileItemPage={openProfileItemPage}
            />
          )}
        </div>
        <div
          onClick={overLayHidden}
          className={` fixed inset-0 min-h-full z-20  bg-black opacity-10 ${
            profileItemPage ? "w-[100%] " : "hidden"
          }`}></div>
      </div>
    </>
  );
};

export default NewContactsItem;
